import React, { useEffect } from "react";
import "../css/home.css";
import { Link } from "react-router-dom";

function Info() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          }
        });
      },
      { threshold: 0.3 } // trigger when 30% visible
    );

    const elements = document.querySelectorAll('.fade-up');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="info-section py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Left: Heading and Paragraph */}
          <div className="col-md-8 text-white mb-3 mb-md-0">
            <h2 className="info-title fade-up">
              Why Choose <span>NeatNest?</span>
            </h2>
            <p className="info-desc fade-up">
              We provide reliable, professional, and affordable home cleaning services. 
              Our trained staff ensures a sparkling clean and hygienic environment 
              so you can relax and enjoy your home.
            </p>
          </div>

          {/* Right: Button */}
          <div className="col-md-4 text-md-end text-center fade-up">
            <Link to="/about" className="btn info-btn">Learn More</Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Info;
